import { useLocale } from "@/i18n";
import clsx from "clsx";

type Props = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  missing?: boolean;
  className?: string;
};

export function SalutationSelect({
  value,
  onChange,
  required = false,
  missing = false,
  className,
}: Props) {
  const { messages } = useLocale();
  const { herr, frau, select } = messages.salutation;

  return (
    <select
      className={clsx("bk-input mt-1", className, missing && "bk-input--missing")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      aria-invalid={missing || undefined}
      autoComplete="honorific-prefix"
    >
      <option value="">{select}</option>
      <option value="Herr">{herr}</option>
      <option value="Frau">{frau}</option>
    </select>
  );
}
